import { render } from "./gdpChart.vue?vue&type=template&id=7b825f10&scoped=true"
import script from "./gdpChart.vue?vue&type=script&lang=js"
export * from "./gdpChart.vue?vue&type=script&lang=js"

import "./gdpChart.vue?vue&type=style&index=0&id=7b825f10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b825f10"]])

export default __exports__